'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fancybox = fancybox;
function fancybox() {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            var target = '';
            element.on('click', function (event) {
                event.preventDefault();
            });

            target = angular.element(element.find('[fb-fancybox]'));
            target.fancybox({
                margin: [48, 48],
                preload: false,
                //fitToView   : true,
                errorTpl: '<div class="fancybox-error"><p translate>The requested content cannot be loaded. <br /> Please try again later.<p></div>',
                closeTpl: '<button data-fancybox-close class="close-btn"><i>x</i></button>'
            });

            scope.$on('$destroy', function () {
                target.unbind('click.fb');
            });

            if (parseInt(extractIdFromParams(attr.galleryId)) === parseInt(attr.index) + 1) {
                setTimeout(function () {
                    element.click();
                });
            }

            function extractIdFromParams(urlParams) {
                return urlParams.substring(8);
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fancybox.js
// module id = 712
// module chunks = 0